import { configure } from 'mobx';

import AppMod from 'widget/App/AppMod';
console.log('AppMod', AppMod);

import AccoumulateMod from 'widget/Accoumulate/AccoumulateMod';

import CommentMod from 'widget/Comment/CommentMod';

// 名片公共组件
import BusinessCard from 'pubBiz/BusinessCard/indexMod';
//移动端活动广告弹窗
import ActiveAdPopupMod from 'pubBiz/ActiveAdPopup/indexMod';

/** 展业 start */
import NewAddMod from 'pages/Promote/Schedule/NewAdd/NewAddMod';
import RemindCustomerMod from 'pages/Promote/Schedule/NewAdd/RemindCustomer/RemindCustomerMod';
import DetailedListMod from 'pages/Promote/Schedule/DetailedList/DetailedListMod';
import BusinessCardMod from 'pages/Promote/BusinessCard/BusinessCardMod';
import AchievementMod from 'pages/Promote/Achievement/AchievementMod';
/** 展业 end */

/** 商城 start */
import LoginMod from 'pages/Login/LoginMod';
import RegisterMod from 'pages/Register/RegisterMod';
import AgreementsMod from 'pages/Shop/Member/Agreements/AgreementsMod';
import AgentRegisterMod from 'pages/Shop/Member/Personal/AgentRegister/AgentRegisterMod';
import MemCardMsgMod from 'pages/Register/MemCardMsg/MemCardMsgMod';
import MsgAddMod from 'pages/Shop/Member/MsgAdd/MsgAddMod';
import ShopHomeMod from 'pages/Shop/Home/ShopHome/ShopHomeMod';
import PersonalMod from 'pages/Shop/Member/Personal/PersonalMod';
import ProductListMod from 'pages/Shop/Product/ProductList/ProductListMod';
import QualificationMod from 'pages/Shop/Product/Qualification/QualificationMod';
import QualificationPageMod from 'pages/Shop/Product/QualificationPage/QualificationPageMod';
import ShoppingCartMod from 'pages/Shop/ShoppingCart/ShoppingCartMod';
import CheckOrderMod from 'pages/Shop/CheckOrder/CheckOrderMod';
import ProtectionMod from 'pages/Shop/Member/Personal/Protection/ProtectionMod';
import SicknessMod from 'pages/Shop/Member/Personal/Sickness/SicknessMod';
import CertificatesMod from 'pages/Shop/Member/Personal/Certificates/CertificatesMod';
import ProfitSharingMod from 'pages/Shop/Member/Personal/ProfitSharing/ProfitSharingMod';
import ProfitSharBindMod from 'pages/Shop/Member/Personal/ProfitSharing/ProfitSharBind/ProfitSharBindMod';
import DetailMod from 'pages/Shop/Member/TradeManage/OrderList/Detail/DetailMod';
import QuestionnaireMod from 'pages/Shop/Member/Questionnaire/QuestionnaireMod';

import NomalWalletMod from 'pages/Shop/Member/Wallet/NomalWallet/NomalWalletMod';
import CisternWalletMod from 'pages/Shop/Member/Wallet/CisternWallet/CisternWalletMod';
import BonusWalletMod from 'pages/Shop/Member/Wallet/BonusWallet/BonusWalletMod';
import ScoreMod from 'pages/Shop/Member/Wallet/Score/ScoreMod';
import QuickBuyMod from 'pages/Shop/Member/TradeManage/QuickBuy/QuickBuyMod';
import QuickBuyForCouponMod from 'pages/Shop/Member/TradeManage/QuickBuyForCoupon/QuickBuyMod';
import ProductDetailMod from 'pages/Shop/Product/ProductDetail/ProductDetailMod';
import ApplyAfterSaleMod from 'pages/Shop/Member/TradeManage/AfterSale/ApplyAfterSale/ApplyAfterSaleMod';
import OrderSwitchMod from 'pages/Shop/Member/TradeManage/OrderSwitch/OrderSwitchMod';

// ----------------店铺
import RegisterStoreMod from 'pages/Register/RegisterStore/RegisterStoreMod';
import StoreCardMsgMod from 'pages/Register/StoreCardMsg/StoreCardMsgMod';
import StudioMsgMod from 'pages/Register/StudioMsg/StudioMsgMod';
import StoreAgentRegisterMod from 'pages/Store/BusinessManage/AgentRegister/AgentRegisterMod';
import StoreAgentMsgMod from 'pages/Store/BusinessManage/StoreAgentMsg/StoreAgentMsgMod';
import StoreWalletMod from 'pages/Store/Wallet/StoreWallet/StoreWallettMod';

// ----------------shop
import AccountMod from 'pages/Shop/Member/Personal/Account/AccountMod';
// ----------------Register
import ViewPackageMod from 'pages/Register/ViewPackage/ViewPackageMod';
// 会员生日mod
import MemberBirthdayMod from 'pages/Shop/Home/MemberBirthday/MemberBirthdayMod';
// 学习培训购买
import BuyModalMod from 'pages/Learn/component/BuyMadol/BuyModalMod';
// 在线开方
import FormulaMod from 'pages/Shop/Formula/FormulaMod';
// 享包邮列表
import FreeShippingMod from 'pages/Shop/Product/FreeShipping/FreeShippingMod';

configure({
  enforceActions: 'never',
  isolateGlobalState: true
});
/** 商城 end */

export default {
  AppMod,
  AccoumulateMod,
  NewAddMod,
  BusinessCard,
  RemindCustomerMod,
  DetailedListMod,
  BusinessCardMod,
  ActiveAdPopupMod,
  AchievementMod,
  LoginMod,
  RegisterMod,
  AgreementsMod,
  AgentRegisterMod,
  MemCardMsgMod,
  MsgAddMod,
  ShopHomeMod,
  PersonalMod,
  ProductListMod,
  QualificationMod,
  QualificationPageMod,
  ShoppingCartMod,
  CheckOrderMod,
  ProtectionMod,
  NomalWalletMod,
  CisternWalletMod,
  BonusWalletMod,
  ScoreMod,
  QuickBuyMod,
  QuickBuyForCouponMod,
  OrderSwitchMod,
  SicknessMod,
  ProfitSharingMod,
  ProfitSharBindMod,
  DetailMod,
  CertificatesMod,
  ApplyAfterSaleMod,
  QuestionnaireMod,
  // 店铺
  RegisterStoreMod,
  StoreCardMsgMod,
  StudioMsgMod,
  StoreAgentRegisterMod,
  StoreAgentMsgMod,
  StoreWalletMod,
  // shop
  AccountMod,
  ProductDetailMod,
  // Register
  ViewPackageMod,
  CommentMod,
  // 会员生日mod
  MemberBirthdayMod,
  // 学习培训购买
  BuyModalMod,
  FormulaMod,
  // 享包邮列表
  FreeShippingMod
};



// WEBPACK FOOTER //
// ./src/config/Stores.js